export const DOM_ELEMENT = {
    VP_PLAYER_HOLDER: 'apps-player-holder',
}